import { ElementType } from "react";

import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import { makeStyles } from "@mui/styles";
import { LinkProps } from "react-router-dom";

import { COLOR_FONT } from "../../../../theme";

interface BaseProps {
  target?: string;
  mobile?: boolean;
  icon?: React.ReactNode;
  dense?: boolean;
  label?: React.ReactNode;
  extraContent?: React.ReactNode;
  iconStyle?: Record<string, string>;
  secondaryLevel?: boolean;
  id?: string;
  onFocus?: () => void;
  onMouseEnter?: () => void;
}

interface LinkMenuItemProps extends BaseProps {
  component: ElementType;
  to: LinkProps["to"];
  onClick?: () => void;
}

interface ButtonMenuItemProps extends BaseProps {
  component?: never;
  to?: never;
  onClick: () => void;
}

type Props = LinkMenuItemProps | ButtonMenuItemProps;

const ContextMenuItem = ({
  component,
  dense = true,
  extraContent,
  icon,
  iconStyle,
  id,
  label = "",
  mobile = false,
  onClick,
  onFocus,
  onMouseEnter,
  secondaryLevel = false,
  target,
  to,
}: Props): React.ReactElement => {
  const classes = useStyles();

  const menuItemProps = {
    className: classes.menuItemLink,
    dense,
    id,
    onClick,
    onFocus,
    onMouseEnter,
    classes: {
      gutters: mobile ? classes.mobileGutters : "",
    },
    ...(component && { component, to, target }),
  };

  return (
    <MenuItem {...menuItemProps}>
      {secondaryLevel && <div className={classes.indent} />}
      {icon && <ListItemIcon style={iconStyle}>{icon}</ListItemIcon>}
      <ListItemText
        classes={{ primary: classes.primaryText }}
        primary={label}
      />
      {extraContent}
    </MenuItem>
  );
};

const useStyles = makeStyles(() => ({
  menuItemLink: {
    "&:hover": {
      textDecoration: "none",
      color: COLOR_FONT.main,
    },
    "&:focus": {
      textDecoration: "none",
      color: COLOR_FONT.main,
      outline: "none",
    },
  },
  primaryText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  mobileGutters: {
    paddingLeft: 32,
    paddingRight: 32,
  },
  indent: {
    width: 16,
  },
}));

export { ContextMenuItem };
